import { Tooltip, UnstyledButton } from '@mantine/core';
import { FC } from 'react';

import NullComponent from '@/components/NullComponent.tsx';

import useConfig from '@/hooks/useConfig.ts';

import { pvs_provider_names } from '@/models/customers/PVSProvider.ts';

import { usePrismicConfigStore } from '@/stores/prismicConfigStore.ts';

interface Props {
    instanceId: string;
}

const InstanceIndicator: FC<Props> = ({ instanceId }) => {
    const { selected_location, config_record } = useConfig();
    const instance_colors = usePrismicConfigStore((state) => state.instance_colors);

    if (selected_location.configs.length <= 1) return <NullComponent />;

    const pvs_provider_name: string = pvs_provider_names[config_record[instanceId]?.pvs_provider] ?? '';

    return (
        <Tooltip label={pvs_provider_name}>
            <UnstyledButton
                className="absolute left-0 top-0 flex size-4 items-center justify-center rounded-br-lg"
                style={{ backgroundColor: instance_colors[instanceId] }}
                onClick={async (e) => {
                    e.stopPropagation();
                    await navigator.clipboard.writeText(instanceId);
                }}
            />
        </Tooltip>
    );
};

export default InstanceIndicator;
